import data from '../../data/pageData.json';
import { ActionTypes } from '../constants/action-types';

const initialState = {
  bannerTitle: data.microformWithPayerAuth.bannerTitle,
  bannerSubtitle: data.microformWithPayerAuth.bannerSubtitle,
  overview: data.microformWithPayerAuth.overview,
  pageDesc: data.microformWithPayerAuth.pageDesc,
  runSequences: data.microformWithPayerAuth.runSequences,
  displayStartOver: data.microformWithPayerAuth.displayStartOver,
  currentStage: data.microformWithPayerAuth.currentStage,
  challengeCardChoosed: data.microformWithPayerAuth.challengeCardChoosed,
  demoToolType: 'microformWithPayerAuth'
};
const consoleInitState = {
  logStages: data.microformWithPayerAuth.consoleLog
};
export const runSequenceReducer = (state = initialState, { type, payload, demoToolType }) => {
  switch (type) {
    case ActionTypes.UPDATE_BANNER:
      return {
        ...state,
        bannerTitle: payload.bannerTitle,
        bannerSubtitle: payload.bannerSubtitle,
        pageDesc: payload.pageDesc,
        overview: payload.overview,
        runSequences: payload.runSequences,
        displayStartOver: false,
        demoToolType: demoToolType
      };
    case ActionTypes.UPDATE_CURRENT_STAGE:
      return {
        ...state,
        currentStage: payload
      };
    case ActionTypes.UPDATE_IS_CHALLENGE_CARD_CHOOSED:
      return {
        ...state,
        challengeCardChoosed: payload
      };
    case ActionTypes.UPDATE_RUN_SEQUENCE:
      return {
        ...state,
        runSequences: state.runSequences.map((sequence) => {
          if (sequence.stage === 2 && sequence.subStages[0].num === 1) {
            sequence.subStages[0].disable = payload === 1 ? false : true;
          }
          if (sequence.stage === 2 && sequence.subStages[1].num === 2) {
            sequence.subStages[1].disable = payload === 1 ? false : true;
          }
          if (sequence.stage === payload + 1) {
            if (!state.challengeCardChoosed && (sequence.stage === 6 || sequence.stage === 7)) {
              return {
                ...sequence,
                disabled: true
              };
            }
            return {
              ...sequence,
              disabled: false
            };
          }
          if (sequence.stage !== payload) {
            return sequence;
          }
          return {
            ...sequence,
            disabled: true
          };
        })
      };

    case ActionTypes.TOGGLE_CHECKOUT_FORM:
      return {
        ...state,
        runSequences: state.runSequences.map((sequence) => {
          if (sequence.stage === 2) {
            return {
              ...sequence,
              microformDisplay: !sequence.microformDisplay
            };
          }
          return {
            ...sequence
          };
        })
      };
    case ActionTypes.TOGGLE_START_OVER_CALLOUT:
      return {
        ...state,
        displayStartOver: payload
      };
    case ActionTypes.SHOW_GIF:
      return {
        ...state,
        runSequences: state.runSequences.map((sequence) => {
          if (
            sequence.stage === 2 &&
            sequence.subStages[0].num === payload.subStage &&
            sequence.subStages[0].gifDisplay
          ) {
            sequence.subStages[0].disable = false;
            sequence.subStages[1].disable = true;
            sequence.disabled = false;
            return {
              ...sequence,
              gifDisplay: false
            };
          } else if (
            sequence.stage === 2 &&
            sequence.subStages[1].num === payload.subStage &&
            sequence.subStages[1].gifDisplay
          ) {
            sequence.disabled = false;
            sequence.subStages[0].disable = true;
            sequence.subStages[1].disable = false;
            return {
              ...sequence,
              gifDisplay: false
            };
          } else if (sequence.stage === 6 && sequence.gifDisplay && state.challengeCardChoosed) {
            return {
              ...sequence,
              gifDisplay: false
            };
          }
          return {
            ...sequence
          };
        })
      };
    default:
      return state;
  }
};

export const consoleLogReducer = (state = consoleInitState, { type, payload }) => {
  switch (type) {
    case ActionTypes.TOGGLE_CONSOLE_LOG:
      return {
        ...state,
        logStages: state.logStages.map((logStage) => {
          if (logStage.stage === payload) {
            return {
              ...logStage,
              isCollapsed: !logStage.isCollapsed
            };
          }
          return logStage;
        })
      };

    case ActionTypes.SET_CONSOLE_LOG_VALUE:
      return {
        ...state,
        logStages: state.logStages.map((logStage) => {
          if (logStage.stage === payload.stage) {
            return {
              ...logStage,
              isCollapsed: false,
              display: true,
              request: {
                title:
                  payload.returnObject.request.title === undefined
                    ? logStage.request.title
                    : payload.returnObject.request.title,
                value: payload.returnObject.request.body
              },
              response: {
                title:
                  payload.returnObject.response.title === undefined
                    ? logStage.response.title
                    : payload.returnObject.response.title,
                value: payload.returnObject.response.body
              },
              decodedResponse: {
                title:
                  payload.returnObject.decodedResponse === undefined
                    ? logStage.decodedResponse.title
                    : payload.returnObject.decodedResponse.title,
                value:
                  payload.returnObject.decodedResponse === undefined
                    ? logStage.decodedResponse.value
                    : payload.returnObject.decodedResponse.value
              }
            };
          }
          return {
            ...logStage,
            isCollapsed: !(logStage.stage === payload.stage)
          };
        })
      };
    case ActionTypes.UPDATE_CONSOLE_LOG_RUN_SEQUENCES:
      if (payload === 'button1') {
        return {
          ...state,
          runSequences: data.microformWithPayerAuth.runSequences.map((sequence) => {
            if (sequence.stage === 1) {
              sequence.disabled = false;
            } else if (sequence.stage === 2) {
              sequence.disabled = true;
              sequence.subStages[0].disable = true;
              sequence.subStages[1].disable = true;
            } else {
              sequence.disabled = true;
            }
          }),
          logStages: data.microformWithPayerAuth.consoleLog
        };
      } else if (payload === 'button2') {
        return {
          ...state,
          runSequences: data.microformOnly.runSequences.map((sequence) => {
            if (sequence.stage === 1) {
              sequence.disabled = false;
            } else if (sequence.stage === 2) {
              sequence.disabled = true;
              sequence.subStages[0].disable = true;
              sequence.subStages[1].disable = true;
            } else {
              sequence.disabled = true;
            }
          }),
          logStages: data.microformOnly.consoleLog
        };
      }
      return {};
    default:
      return state;
  }
};
